module.exports = __webpack_public_path__ + "static/media/whats-app-fale-conosco.e02651cc.png";